import { useTravelInfoUpdaters } from '../context/index'

export function useTravelInfoPromptActiveStateManager() {
    const { activate, reset } = useTravelInfoUpdaters()
    return { onTravelInfoEnter: activate, onTravelInfoExit: reset }
}
